<app-spinner *ngIf="!loaded"></app-spinner>
<div class="se-app" *ngIf="loaded">
  <div class="se-app__main">
    <div class="se-app__content">
      <div class="se-app__header--align-center">
        <span *ngIf="organization.id"
          class="se-app__logo--right-margin"
          [ngStyle]="{'background-image': 'url(' + organization.logo.url + ')'}">
          <span *ngIf="organization.logo.is_default"
          class="pl-avatar__initial">{{ organization.name.substring(0, 1) }}</span>
        </span>
        <h2 class="se-app__content-title">{{ organization.name }}</h2>
      </div>
      <div class="se-app__section">
        <div class="se-block">
          <div class="pl-user-avatar--large" style="flex-shrink: 0;">
            <div class="pl-user-avatar__image{{ card.persona.hasProfileImage ? '--custom' : '' }}"
              [ngStyle]="card.persona.hasProfileImage && {'background-image': 'url(' + card.persona.profileImage('crop') + ')'}">
            </div>
          </div>
          <div class="se-app__content-title--center">
            <h1 class="se-app__content-title--alt">{{ legalOrProfileName }}</h1>
          </div>
          <div class="se-app__content-subheading--center">
            <p class="se-text se-block">{{ card.number.number }}</p>
          </div>
        </div>
      </div>
      <div class="border-bottom" style="padding-bottom: 36px;">
        <se-empty-state
          *ngIf="!membershipItems.length"
          se-data-title="No Memberships"
          se-data-subtle="true">
          <div se-cp-empty-state-description>There are no active memberships for {{ legalOrProfileName }} right now.</div>
        </se-empty-state>
        <div *ngIf="membershipItems.length">
          <div class="se-app__content-separated se-text">MEMBERSHIPS</div>
          <div class="se-app__content-separated" *ngFor="let membershipItem of membershipItems">
            <app-membership-item [membershipItem]="membershipItem"></app-membership-item>
          </div>
        </div>
      </div>
      <app-footer
        [organization]="organization"
        [ga]="{ }"></app-footer>
    </div>
  </div>
  <app-subfooter></app-subfooter>
</div>
